import { render, staticRenderFns } from "./SafetyStock.vue?vue&type=template&id=1bda2b94&scoped=true"
import script from "./SafetyStock.vue?vue&type=script&lang=js"
export * from "./SafetyStock.vue?vue&type=script&lang=js"
import style0 from "./SafetyStock.vue?vue&type=style&index=0&id=1bda2b94&prod&lang=css"
import style1 from "./SafetyStock.vue?vue&type=style&index=1&id=1bda2b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bda2b94",
  null
  
)

export default component.exports